import { Navigate, Outlet } from "react-router-dom"; 
// import {Outlet} from "react-router-dom";
import getCookie from "./cookieUtils";

const RequireAuth = () => {
  const userRoles = JSON.parse(localStorage.getItem("roles"));
  const token = getCookie("token");



  const allowedRoles = {
    super: "org.admin.super",
    assistant: "org.admin.assistant",
    courseAdmin: "org.admin.course",
    integration: "org.admin.integration",
    department: "org.admin.department",
  };

  const hasRequiredRole = userRoles?.find((role) =>
      Object.values(allowedRoles).includes(role)
  );

  // Only check if token EXISTS, not if it's valid
  // The interceptor handles expiry by attempting a refresh
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!hasRequiredRole) {
    return <Navigate to="/unauthorized" />;
  }

  return <Outlet />;
};

export default RequireAuth;